import { render } from "./auth-layout.vue?vue&type=template&id=240e0221"
import script from "./auth-layout.vue?vue&type=script&lang=js"
export * from "./auth-layout.vue?vue&type=script&lang=js"

import "./auth-layout.vue?vue&type=style&index=0&id=240e0221&lang=scss"
script.render = render

export default script